// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] || chunkId) + "." + {"102":"31698191","133":"61e7e312","182":"a2a5788c","453":"a8fee937"}[chunkId] + ".chunk.js";
};